<template>
  <l-map ref="map" :zoom="zoom" :center="center" :use-global-leaflet="false">
    <l-tile-layer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    ></l-tile-layer>
    
  </l-map>
  <!-- </div> -->
</template>

<script lang="ts">
import { ref } from "vue";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import { icon } from "leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props: {},
  emits: ["marker-clicked"],
  setup(props, { emit }) {
    const zoom = ref(12);
    const center = ref([-6.2, 106.816666]);

    const customIcon = ref(
      new icon({
        iconUrl: "/images/map-both.png",
        iconSize: [50, 55],
      })
    );

    const getIcon = (type: string) => {
      if (type == "Mobil & Motor") {
        return new icon({
          iconUrl: "/images/map-both.png",
          iconSize: [50, 55],
        });
      } else if (type == "Mobil") {
        return new icon({
          iconUrl: "/images/maker-car.png",
          iconSize: [50, 55],
        });
      } else if (type == "Motor") {
        return new icon({
          iconUrl: "/images/maker-motor.png",
          iconSize: [50, 55],
        });
      }
    };

    const handleClick = (item: any) => {
      emit("marker-clicked", item);
    };

    return {
      zoom,
      center,
      customIcon,
      getIcon,
      handleClick,
    };
  },
};
</script>

<style scoped>
.custom-popup {
  width: 1000px;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}

.custom-popup button {
  width: 100%;
  margin-top: 10px;
  background-color: #f9f9f9;
}

/* 
#map-container {
  position: relative;
}

#search-field {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
}

#radio-buttons {
  position: absolute;
  top: 50px;
  left: 10px;
  z-index: 1000;
} */
</style>

